import React from 'react'
import { MdOutlinePlace } from "react-icons/md";
import { FaStamp } from 'react-icons/fa';
import { parseISO, format } from "date-fns";


export default function MinorRequestDetailsMobile({ request, divBoleto, divContato, divRecebido, localizacaoEquip, carimboDespacho }) {
  const equipmentRows = (request?.equipamentos && request?.equipamentos.length > 0)
    ? request.equipamentos
    : request
    ? [{
        _id: request._id,
        codSap: request.codSap,
        nomeEquipamento: request.nomeEquipamento,
        partNumberEquipamento: request.partNumberEquipamento,
        fabricanteEquipamento: request.fabricanteEquipamento,
        quantidade: request.quantidadeSolicitada,
      }]
    : [];

  return (
    <div className="flex flex-col gap-2 mt-2 mx-1 text-xs">
      {/* Solicitante */}
      <div className="bg-gray-50 border rounded-lg p-3 flex flex-col gap-1">
        <div className="font-semibold text-gray-700 mb-1">Solicitante</div>
        <div><span className="font-semibold">Nome:</span> {request?.nomeSolicitante}</div>
        <div><span className="font-semibold">RE/Legal:</span> {request?.reLegalSolicitante}</div>
        <div><span className="font-semibold">UF:</span> {request?.uf}</div>
        <div><span className="font-semibold">Empresa:</span> {request?.empresaSolicitante}</div>
        <div><span className="font-semibold">Contato:</span> {request?.telefone}</div>
      </div>

      {/* Equipamento */}
      <div className="bg-gray-50 border rounded-lg p-3 flex flex-col gap-1">
        <div className="font-semibold text-gray-700 mb-1">Equipamento</div>
        <div className="flex flex-col gap-2">
          {equipmentRows.map((equipment, index) => (
            <div key={equipment._id || `${equipment.codSap}-${equipment.partNumberEquipamento}-${index}`} className="rounded-md border border-zinc-300 bg-white p-2 shadow-sm">
              <div><span className="font-semibold">Cod. SAP:</span> {equipment.codSap}</div>
              <div><span className="font-semibold">Nome:</span> {equipment.nomeEquipamento}</div>
              <div><span className="font-semibold">Part Number:</span> {equipment.partNumberEquipamento}</div>
              <div><span className="font-semibold">Fabricante:</span> {equipment.fabricanteEquipamento}</div>
              <div><span className="font-semibold">Qtd:</span> {equipment.quantidade}</div>
            </div>
          ))}

        {request?.codSapAlternativo && (
          <div className="text-blue-500">
            <span className="font-semibold">*SAP alternativo:</span> {request?.codSapAlternativo}
          </div>
        )}

        {localizacaoEquip && (
          <div className="flex gap-6 w-full">
            <div className="flex items-center w-full gap-1 border border-gray-700 rounded-full px-2 py-1 bg-white">
              <MdOutlinePlace size={14} />
              <span className="font-semibold">Localização:</span>
              <span>{request?.localizacaoPrateleira}</span>
            </div>
          </div>
        )}

          <div className="overflow-hidden rounded-md border border-zinc-300 bg-white shadow-sm mt-1">
            <table className="min-w-full text-[10px] text-left text-gray-700">
              <thead className="bg-gray-200">
                <tr>
                  <th colSpan="2" className="px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.12em] text-gray-600 bg-zinc-100 border-b border-zinc-300">
                    Quantidades
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-zinc-200 align-middle">
                  <td className="px-2 py-1 font-bold text-gray-700">Qtd Solicitada</td>
                  <td className="px-2 py-1 text-center">{request?.quantidadeSolicitada}</td>
                </tr>
                <tr className="border-t border-zinc-200 align-middle">
                  <td className="px-2 py-1 font-bold text-gray-700">Qtd Cortada</td>
                  <td className="px-2 py-1 text-center">{request?.quantidadeCortada}</td>
                </tr>
                <tr className="border-t border-zinc-200 align-middle">
                  <td className="px-2 py-1 font-bold text-gray-700">Qtd a Atender</td>
                  <td className="px-2 py-1 text-center">{request?.quantidadeAtender}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Boleto */}
      {divBoleto && (
        <div className="bg-gray-50 border rounded-lg p-3 flex flex-col gap-1">
          <div className="font-semibold text-gray-700 mb-1">Boleto</div>
          <div><span className="font-semibold">Identificação:</span> {request?.idBoleto}</div>
          <div><span className="font-semibold">Tipo:</span> {request?.tipoBoleto?.toUpperCase()}</div>
          <div><span className="font-semibold">Tipo Atendimento:</span> {request?.tipoAtendimento?.toUpperCase()}</div>
          <div className="font-bold mt-1">
            <span className="font-semibold">Atender até:</span>{" "}
            {request?.slaDate ? format(parseISO(request?.slaDate), 'dd/MM/yy HH:mm') : ""}
          </div>
        </div>
      )}

      {/* Site/Entrega */}
      <div className="bg-gray-50 border rounded-lg p-3 flex flex-col gap-1">
        {/* <div className="font-semibold text-gray-700 mb-1">Entrega</div> */}
        <div><span className="font-semibold">Site:</span> {request?.site}</div>
        <div>
          <span className="font-semibold">GMO:</span> {request?.gmo?.cidade}
          {request?.gmo?.identificador ? ` - ${request.gmo.identificador}` : ""}
        </div>
        <div><span className="font-semibold">DRS Original:</span> {request?.drsOriginal?.sigla}</div>
        <div><span className="font-semibold">DRS Atender:</span> {request?.drsAtender?.sigla || "-"}</div>
        <div><span className="font-semibold">Endereço GMO:</span> {request?.gmo?.endereco}</div>
        <div><span className="font-semibold">Cidade GMO:</span> {request?.gmo?.cidade}</div>
      </div>

      {/* Contato Técnico */}
      {divContato && (
        <div className="bg-gray-50 border rounded-lg p-3 flex flex-col gap-1">
          <div className="font-semibold text-gray-700 mb-1">Técnico/Entrega</div>
          <div><span className="font-semibold">Nome:</span> {request?.tecnico}</div>
          <div><span className="font-semibold">Telefone:</span> {request?.telefone}</div>
          <div><span className="font-semibold">Endereço Entrega:</span> {request?.enderecoEntrega}</div>
          <div><span className="font-semibold">Cidade Entrega:</span> {request?.cidadeEntrega}</div>
          <div><span className="font-semibold">Complemento:</span> {request?.enderecoEntregaComplemento}</div>
        </div>
      )}

      {/* Recebido */}
      {divRecebido && (
        <div className="bg-gray-50 border rounded-lg p-3 flex flex-col gap-1">
          <div className="font-semibold text-gray-700 mb-1">Recebido</div>
          <div><span className="font-semibold">Recebido Por:</span> {request?.recebidoPor}</div>
          {request?.matriculaRecebedor ? (
            <div><span className="font-semibold">Matrícula:</span> {request?.matriculaRecebedor}</div>
          ) : (
            <div><span className="font-semibold">Doc Recebedor:</span> {request?.docRecebedor}</div>
          )}
        </div>
      )}

      {/* Carimbo para o Despacho */}
      {carimboDespacho && (
        <div className="bg-gray-50 border rounded-lg p-3 flex flex-col gap-1">
          <div className="flex items-center gap-1 text-gray-700 font-semibold mb-1">
            <FaStamp />
            Carimbo Backoffice:
          </div>
          <div className="w-full px-2 py-1 rounded-lg bg-white border text-neutral-600 font-normal">
            {request?.ultimoCarimbo}
          </div>
        </div>
      )}
    </div>
  )
}
